import { useState, useEffect } from 'react';
import { api } from '../api';

/**
 * Resolves a stored fileId to a pre-signed download URL.
 * Returns null while the URL is loading or if fileId is null.
 */
export function useFileUrl(fileId: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!fileId) {
      setUrl(null);
      return;
    }
    let cancelled = false;
    api
      .getDownloadUrl(fileId)
      .then((r) => {
        if (!cancelled) setUrl(r.downloadUrl);
      })
      .catch(() => {
        // URL resolution failure is non-fatal; component just won't show a preview.
      });
    return () => {
      cancelled = true;
    };
  }, [fileId]);

  return url;
}
